module.exports = __webpack_public_path__ + "media/site/images/products/avisboard-flat-screen3-5fc708e25bf9ac1e7984e499dd025c7b.png";